import React from 'react';

interface IPasswordStateProps {
    password?: string;
}

const PasswordStates: React.FC<IPasswordStateProps> = ({ password }) => {
    return (
        <div id='passwordStates' className='password-error-container'>
            <div className='password-errors'>
                <p id='minLength' className='invalid'>
                    8-60 characters
                </p>
                <p id='uppercaseLetter' className='invalid'>
                    1 uppercase letter
                </p>
            </div>
            <div className='password-errors'>
                <p id='numbers' className='invalid'>
                    1 number
                </p>
                <p id='lowercaseLetter' className='invalid'>
                    1 lowercase letter
                </p>
            </div>
            <div className='password-errors'>
                <p id='specialChars' className='invalid'>
                    1 special character
                </p>
            </div>
        </div>
    );
};

export default PasswordStates;
